// Port of api/fuel/app/classes/insights/game/recommendations.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'recommendations',
    priority: 2,
    enabled: false,
    requires: ['init'],
    insight: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var user_id = owner.get_id()
        var game_id = parseInt(vars.id, 10)

        // Get this game's mechanic IDs
        var mechanicRows = Util.queryFast(
            'SELECT mechanic_id FROM game_mechanic WHERE game_id = ' + game_id
        )

        var mechanicIds = Util.pluck(mechanicRows, 'mechanic_id')
        if (!mechanicIds.length) return {}

        // Under-explored: games sharing 2+ mechanics that user owns but played <= 2 times
        var underRows = Util.queryFast(
            'SELECT gm.game_id, COUNT(DISTINCT gm.mechanic_id) AS shared_mechanics, ' +
            'COALESCE(SUM(p.play_count), 0) AS total_plays ' +
            'FROM game_mechanic gm ' +
            'JOIN collection c ON c.game_id = gm.game_id AND c.user_id = ' + user_id + ' AND c.collection_own = 1 ' +
            'LEFT JOIN play p ON p.game_id = gm.game_id AND p.user_id = ' + user_id + ' ' +
            'WHERE gm.mechanic_id IN(' + Util.in(mechanicIds) + ') AND gm.game_id != ' + game_id + ' ' +
            'GROUP BY gm.game_id ' +
            'HAVING shared_mechanics >= 2 AND total_plays <= 2 ' +
            'ORDER BY shared_mechanics DESC, total_plays ASC LIMIT 10'
        )

        var underExplored = []
        for (var ui = 0; ui < underRows.length; ui++) {
            var gid = parseInt(underRows[ui].game_id, 10)
            underExplored.push({
                id: gid,
                sharedMechanics: parseInt(underRows[ui].shared_mechanics, 10),
                totalPlays: parseInt(underRows[ui].total_plays, 10)
            })
            this._references.games.push(gid)
        }

        // You might like: games sharing 2+ mechanics user doesn't own with high avg ratings
        // No Booster in offline mode
        var likeRows = Util.queryFast(
            'SELECT gm.game_id, COUNT(DISTINCT gm.mechanic_id) AS shared_mechanics, ' +
            'AVG(r.rating_value) AS avg_rating, COUNT(DISTINCT r.rating_id) AS rater_count ' +
            'FROM game_mechanic gm ' +
            'JOIN rating r ON r.game_id = gm.game_id AND r.rating_value > 0 ' +
            'WHERE gm.mechanic_id IN(' + Util.in(mechanicIds) + ') AND gm.game_id != ' + game_id + ' ' +
            'AND gm.game_id NOT IN(SELECT game_id FROM collection WHERE user_id = ' + user_id + ' AND collection_own = 1) ' +
            'GROUP BY gm.game_id ' +
            'HAVING shared_mechanics >= 2 AND rater_count >= 5 ' +
            'ORDER BY avg_rating DESC, shared_mechanics DESC LIMIT 10'
        )

        var mightLike = []
        for (var li = 0; li < likeRows.length; li++) {
            var lgid = parseInt(likeRows[li].game_id, 10)
            mightLike.push({
                id: lgid,
                sharedMechanics: parseInt(likeRows[li].shared_mechanics, 10),
                avgRating: Math.round(parseFloat(likeRows[li].avg_rating) * 100) / 100,
                raterCount: parseInt(likeRows[li].rater_count, 10)
            })
            this._references.games.push(lgid)
        }

        return {
            recommendations: {
                underExplored: underExplored,
                mightLike: mightLike
            }
        }

    }
})
